/* Simplyfour — custom interactions (vanilla, no libraries) */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.sf-reveal:not(.sf-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sf-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sf-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGallery(root) {
    var main = root.querySelector('[data-sf-main]');
    var thumbs = root.querySelectorAll('[data-sf-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(root, btn.getAttribute('data-sf-thumb')); });
    });
  }

  function showMedia(root, mediaId) {
    var main = root.querySelector('[data-sf-main]');
    var btn = root.querySelector('[data-sf-thumb="' + mediaId + '"]');
    if (!main || !btn) return;
    main.src = btn.getAttribute('data-sf-src');
    main.removeAttribute('srcset');
    main.alt = btn.getAttribute('data-sf-alt') || '';
    root.querySelectorAll('[data-sf-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === btn); });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-sf-variants]');
    initGallery(root);
    initQty(root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var idInput = root.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-sf-add]');
    var btnText = btn ? btn.querySelector('[data-sf-add-text]') : null;
    var addLabel = root.getAttribute('data-add-label');
    var soldLabel = root.getAttribute('data-sold-label');

    function update() {
      var selected = [];
      root.querySelectorAll('[data-sf-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
        var label = fs.querySelector('[data-sf-option-value]');
        if (label && checked) label.textContent = checked.value;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      root.querySelectorAll('[data-sf-price]').forEach(function (el) { el.textContent = formatMoney(variant.price, moneyFormat); });
      root.querySelectorAll('[data-sf-compare]').forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        el.textContent = show ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        el.hidden = !show;
      });
      root.querySelectorAll('[data-sf-save]').forEach(function (el) {
        var show = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (show) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          el.textContent = (el.getAttribute('data-sf-save') || 'Save [percent]%').replace('[percent]', pct);
        }
        el.hidden = !show;
      });
      if (btn) {
        if (variant.available) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
        else { btn.setAttribute('disabled', 'disabled'); }
        if (btnText) btnText.textContent = variant.available ? addLabel : soldLabel;
      }
      if (variant.featured_media_id) showMedia(root, String(variant.featured_media_id));
      if (window.history && window.history.replaceState && root.hasAttribute('data-sf-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-sf-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  function initQty(root) {
    var wrap = root.querySelector('[data-sf-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = b.getAttribute('data-sf-step') === 'up' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-sf-sticky]');
    var target = document.querySelector('[data-sf-add]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-shown', past);
      });
    });
    io.observe(target);
    bar.querySelector('button').addEventListener('click', function () {
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function initAll() {
    initReveal();
    document.querySelectorAll('[data-sf-product]').forEach(initProduct);
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initReveal);
})();
